import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { IconChevronRight } from 'src/components/Icons/ChevronRight';
import { SidebarModelResponse } from 'src/models/Partner/Sidebar';
import { commonSlice } from 'src/store/commonPart/slice';
import { ItemButton } from '../common/Item/Button';
import { IconSwitch } from './icons';
import { OrganizationsList } from './OrganizationsList';
import styles from './styles.module.scss';

type Props = {
  title: string;
  testId: string;
  onOpen: () => void;
  onClose: () => void;
  organizations: SidebarModelResponse['OrganizerOrganizations'];
  show: boolean;
};

export const SwitchOrganization: FC<Props> = ({ title, onOpen, onClose, testId, organizations, show }) => {
  const dispatch = useDispatch();

  const changeCurrentOrganization = useCallback(
    (orgUrl: string) => {
      dispatch(commonSlice.actions.changeOrganizationStart(orgUrl));
    },
    [dispatch]
  );

  return (
    <>
      <ItemButton
        testId={testId}
        title={title}
        icon={IconSwitch}
        onClick={onOpen}
        suffix={<IconChevronRight className={styles.iconChevron} />}
      />

      {show && (
        <OrganizationsList
          items={organizations}
          onClose={onClose}
          onChangeCurrentOrganization={changeCurrentOrganization}
        />
      )}
    </>
  );
};
